import moment from 'moment';

export const now = moment()?.toString();

export const servicesMinDate = moment('07/03/2023')?.toString();
export const tenantMinDate = moment('01/10/2024')?.toString();
